export const summaryGroupingOptions = ['brand', 'host', 'experience'] as const;
export type SummaryGroupingOption = (typeof summaryGroupingOptions)[number];
